import React, { useState } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import MDBox from "shared/components/MDBox";
import HeaderJobOrder from "./components/HeaderjobOrder";
import TableJobOrder from "./components/TableJobOrder";

const JobOrder = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);

  const handleUserCreated = () => {
    setRefreshFlag((prev) => !prev);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={0} />
      <HeaderJobOrder onUserCreated={handleUserCreated}>
        <MDBox mt={2} mb={0}>
          <TableJobOrder refreshFlag={refreshFlag} />
        </MDBox>
      </HeaderJobOrder>
    </DashboardLayout>
  );
};

export default JobOrder;
